import React from 'react';
import { toast } from 'react-toastify';
import styles from './Notification.scss';
const Notification = ({ image, title, subTitle, interactive, }) => (React.createElement("div", { className: styles.notification },
    React.createElement("div", { className: styles.image }, typeof image === 'string'
        ? React.createElement("img", { alt: "", src: image })
        : image),
    React.createElement("div", { className: styles.body },
        title && React.createElement("div", { className: styles.title }, title),
        subTitle && React.createElement("div", { className: styles.subTitle }, subTitle),
        interactive && React.createElement("div", { className: styles.interactive }, interactive))));
Notification.defaultProps = {
    image: undefined,
    title: undefined,
    subTitle: undefined,
    interactive: undefined,
};
export default (myProps, toastProps) => toast(React.createElement(Notification, { ...myProps }), { ...toastProps });
